<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :class="searchClass"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @getTableConfigList="getTableConfigList"
            @changeSecondQueryCondition="changeSecondQueryCondition"
            @cellClick="cellClick">
            <div slot="search-checkBox" class="search-checkBox">
                   <div>
                        是否查询ES
                        <el-checkbox
                            true-label="2"
                            false-label="1"
                            v-model="invokeMethod"
                        ></el-checkbox>
                    </div>
                </div>
                <template v-slot:page-module-btn>
                    <div class="btnList">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="openExportModal"
                            >批量查询导出</el-button
                        >

                        <reportExport #default="{ submit }" reportCode="">
                            <el-button
                                size="mini"
                                type="primary"
                                @click="searchExport(submit)"
                                >导出</el-button
                            >
                        </reportExport>
                    </div>
                </template>
        </m-table>
        <multipleImport ref="multiple"
            :templateExport="templateExport"
            :searchData="defaultSearchData"
            @uploadImport="uploadImport">
        </multipleImport>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { wholeProcessTrackingSearch, uploadProcess } from '@/modules/sn/api/lcbsManagement.js';
import { tableConfig } from './tableConfig.js';
import multipleImport from '../component/multipleImport';
import { cloneDeep } from 'lodash';
import reportExport from '@/components/lots/reportExportPlugin';
// import { dictWithUrl } from '@/modules/sn/components/basicDataDialog/api';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { replace } from '@/modules/sn/utils/generalOption';
import { searchByDictCodes, listByTenantCode } from '@/modules/sn/api/systemManagementApi.js';
import { fetchEyeInfoLog } from '@/modules/sn/api/productProcess.js';
const EXPORT_API = '/api-sn/lbcs/barcodeFullProcessTracking/export'; // 通用导出接口路径
export default {
    name: 'barcodeProcess',
    components: {
        Paper,
        mTable,
        reportExport,
        multipleImport
    },
    data() {
        return {
            barcodeNo: '', // 弹出框单号
            currentIndex: 0, // 弹出框下标
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            pickerMinDate: '', // 计算禁用时间
            tableConfig: {}, // 表格配置
            listExportParams: {}, // 导出参数（默认当前查询记录）
            exportColumns: [], // 导出行
            dictObj: {},
            searchClass: '',
            defaultSearchData: {
                isReadTheEnd: '0'
            },
            invokeMethod: '2',
            templateExport: {
                 exportUrl:
                    '/api-sn/lbcs/barcodeFullProcessTracking/templates/download',
                exportName: this.$translate('lang.E3202101280017', {
                    defaultText: 'LBCS条码全流程批量查询模板.xlsx'
                }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260014', {
                    defaultText: '批量查询模板下载'
                }),
                exportFlag: 1,
                type: 'get'
            }
            // shipStatusDictList: {}, // 出货状态字典
            // stateDictList: {} // 可用状态字典
        };
    },
    mounted() {
        this.tableConfig = tableConfig;
        this.handleDicts();
        this.dictData();
        this.getSceneDomainList();
        // this.dictData();
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        // 列配置
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        // 检查输入参数
        checksSearchData(data) {
            let isLabel = '';
            let isDate = false;
            Object.keys(this.searchData).forEach(key => {
                if (!this.searchData[key] || this.searchData[key].length === 0) {
                    delete this.searchData[key];
                }
                const index = key.indexOf('Date');
                if (index !== -1) {
                    isDate = true;
                    if (Array.isArray(this.searchData[key])) {
                        this.searchData[key + 'Start'] = this.searchData[key][0];
                        this.searchData[key + 'End'] = this.searchData[key][1];
                        const sevenDaysLater = dayjs(this.searchData[key][0]).add(31, 'day').format('YYYY-MM-DD');
                        if (this.searchData[key][1] > sevenDaysLater) {
                            isLabel = this.tableConfig.searchList.searchTxt.filter(item => item.value === key)[0].name;
                        }
                        delete this.searchData[key];
                    }
                }
            });
            if (!this.searchData.barcodeNoSplit && !this.searchData.sourceBillNo && !this.searchData.taskNo) {
                if (this.invokeMethod === '1') {
                    this.$message.warning('单据号/条码号/任务号不能同时为空');
                    return false;
                } else {
                    if (!isDate) {
                        this.$message.warning('单据号/条码号/任务号同时为空，请选择一个时间范围条件查询');
                        return false;
                    }
                }
            }
            if (isLabel) {
                this.$message.warning(`${isLabel}查询范围不能大于31天`);
                return false;
            }
            if (!Object.values(this.searchData).length) {
                this.$message.warning('请先输入至少一个查询条件！');
                return false;
            }
            return true;
        },
        // onSearchDataChange(data) {
        //     this.searchData = data;
        // },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.getData();
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.getData();
        },
        // 查询
        search(data) {
             this.searchData = {
                ...data
            };
            const flag = this.checksSearchData();
            this.tableConfig.page.pageNo = 1;
            if (flag) {
                this.getData();
            } else {
                this.listData = [];
                this.pageTotal = 0;
            }
        },
        getData() {
             const params = {
                param: cloneDeep(this.searchData),
                tenantCode: this.currentTenant.tenantCode,
                invokeMethod: this.invokeMethod
            };
            params.param.pageSize = this.tableConfig.page.pageSize;
            params.param.pageNo = this.tableConfig.page.pageNo;
            params.param.domainList = ['物流运输'];
            this.listExportParams = params;
            wholeProcessTrackingSearch(params).then((res) => {
                if (res.code + '' === '0' && res.data.logisticsTransportationResp) {
                    this.setData(res.data.logisticsTransportationResp.pageResp);
                } else {
                    this.listData = [];
                    this.pageTotal = 0;
                }
            });
        },
        setData(data) {
            this.pageTotal = data.totalCount;
            this.listData = data.list.map((item) => {
                // item.state = item.state ? this.stateDictList[item.state] : '';
                // item.shipStatus = item.shipStatus
                //     ? this.shipStatusDictList[item.shipStatus]
                //     : '';
                // item.id = item.id + '';
                item.shipOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.shipOrgType];
                item.recOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.recOrgType];
                item.senderDetailAddrDees = item.senderDetailAddr ? replace(item.senderDetailAddr) : '';
                item.receiverDetailAddrDees = item.receiverDetailAddr ? replace(item.receiverDetailAddr) : '';
                return item;
            });
        },
        // 单元格点击查询全部单元格信息
       cellClick(data) {
            this.listData.some(item => {
                if (item.swapId === data.swapId) {
                    if (data.property.indexOf('Dees') > -1) {
                        const key = item[data.property.replace('Dees', '')];
                        if (item[data.property] !== key) {
                            if (!key) return;
                            item[data.property] = key;
                            const params = {
                                model: '条码全流程跟踪',
                                describe: `查看${data.label}`,
                                result: 'successful',
                                action: 'acces',
                                url: '/barcode/swap/wholeProcess'
                            };
                            fetchEyeInfoLog(params);
                            return true;
                        } else {
                            item[data.property] = replace(key);
                        }
                    }
                }
            });
        },
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE'
            };
            searchByDictCodes(params).then((res) => {
                if (res && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const obj = {};
                        res.data[key].forEach((item) => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        },
        changeSecondQueryCondition(flag) {
            flag ? this.searchClass = '' : this.searchClass = 'table_height';
        },
        async dictData() {
            const params = {
                dictCodes: 'ORDER_SYSTEM,SCAN_SYSTEM,SCAN_WH_CODE'
            };
            const option = await searchByDictCodes(params);
            this.tableConfig.searchList.searchTxt.forEach((item) => {
                if (item.dicOptionsKey && option.data[item.dicOptionsKey]) {
                    item.options = this.dicEnable(option.data, item.dicOptionsKey);
                }
            });
        },
        // 对数据字典进行格式处理
        dicEnable(options, key) {
            if (options[key]) {
                let data = options[key];
                data = data.filter(item => {
                    item.name = `${item.code}-${item.name}`;
                    return item.tenantCode === this.currentTenant.tenantCode || item.def1 === this.currentTenant.tenantCode;
                });
                const list = data.map(item => {
                    return {
                        label: item.name,
                        value: item.code
                    };
                });
                return list;
            }
        },
        // 获取单据类型下拉查询数据
        getSceneDomainList() {
            const params = {
                pageNo: 1,
                pageSize: 100,
                tenantCode: this.currentTenant.tenantCode
                // sourceSys: val[0]
            };
            listByTenantCode(params).then(res => {
                if (res.code === '0' && res.data) {
                    this.tableConfig.searchList.searchTxt.forEach((item) => {
                        if (item.value === 'billTypeClass') {
                            item.options = res.data.map(row => ({
                                label: row.billTypeName,
                                value: row.billTypeName
                            }));
                        }
                    });
                }
            });
        },
        openExportModal() {
            this.$refs.multiple.orderImportC();
        },
        // 导出
        searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.listExportParams,
                ...this.listExportParams.param
            };
            delete params.param;
            if (!this.listData.length) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            };
            submit(params);
        },
        uploadImport(form, submit) {
           uploadProcess(form).then(res => {
                if (res && +res.code === 0) {
                    const params = {
                        EXPORT_API: '/api-sn/barcode/swap/wholeProcess/batchExport',
                        barcodeBatchNo: res.data
                    };
                    submit(params);
                    this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 305px) !important;
    }
}
.table_height{
    /deep/ .el-table {
        height: calc(100vh - 230px) !important;
    }
}
.search-checkBox {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333333;
}
</style>
